import fitHeight from './fitHeight.js';
import fitWidth from './fitWidth.js';
import getAspectRatio from './utils/getAspectRatio.js';

/**
 * Child is scaled to cover the whole parent.
 * Child aspect ratio is preserved.
 * Child will be clipped to fit if its aspect ratio doesn't match the parent's.
 * @param {object} parent
 * @param {object} child
 * @returns {object}
 */
const cover = (parent, child) => {
  if (getAspectRatio(child) < getAspectRatio(parent)) {
    return fitWidth(parent, child);
  }
  return fitHeight(parent, child);
};

export default cover;
